import { useContext } from 'react';

import { DependencyContext } from '../DependencyContext';

// ...

export const useDependency = (key) => {
  return useContext(DependencyContext)[key];
};
